import { IStaticPage } from 'remote/queries/static-page';

import { WidgetType } from './widgetEnums';

/**
 * Checks if Fixed CTA Widget is present in the list of widgets of the static page.
 * @param page IStaticPage
 * @returns boolean
 */
export const isFixedCallToActionWidgetPresent = (page: IStaticPage): boolean =>
  page.widgets?.some(
    (item: { _type: WidgetType }) => item._type === WidgetType.FIXED_CALL_TO_ACTION
  );
